import React from 'react';
import PropTypes from 'prop-types';
import { convertDateToDayMonthYear, convertTime } from '../../../../lib/formatDate';
import { Button } from '../../../shared/_form';
import { tradeCancelModal } from '../../../../constants/modals';
import CancelTradeRequestModal from '../CancelTradeRequestModal';
import Immutable from 'immutable';

const TradeOffersRequestedDesktop = ({ tradeOffersRequested, onHandleShowTradeAcceptModal }) => {
  return (
    tradeOffersRequested.valueSeq().map((tradeOfferRequested) => (
      <React.Fragment key={ tradeOfferRequested.get('id') }>
        <div className='trade-post__row' key={ tradeOfferRequested.get('id') }>
          <div className='trade-post__cell trade-post__office'>
            {tradeOfferRequested.getIn(['requestedAppointment', 'office', 'name'])}
          </div>
          <div className='trade-post__cell trade-post__requester'>
            {tradeOfferRequested.getIn(['receiver', 'name'])}
          </div>
          <div className='trade-post__cell trade-post__offered-appt'>
            {convertDateToDayMonthYear(tradeOfferRequested.getIn(['offeredAppointment', 'scheduledOn']))}{' '}
            {convertTime(tradeOfferRequested.getIn(['offeredAppointment', 'from']))}
          </div>
          <div className='trade-post__cell trade-post__requested-appt'>
            {convertDateToDayMonthYear(tradeOfferRequested.getIn(['requestedAppointment', 'scheduledOn']))}{' '}
            {convertTime(tradeOfferRequested.getIn(['requestedAppointment', 'from']))}
          </div>
          <div className='trade-post__cell trade-post__status'>
            <span className={ 'trade-post__trade-status trade-post__trade-status--pending' } >
              {tradeOfferRequested.get('status')}
            </span>
          </div>
          <div className={ 'trade-post__buttons' }>
            <Button className='trade-post__cancel-button'
              onClick={ onHandleShowTradeAcceptModal(tradeCancelModal(tradeOfferRequested.get('id'))) }
            >
                Cancel
            </Button>
          </div>
        </div>
        <CancelTradeRequestModal id={ tradeCancelModal(tradeOfferRequested.get('id')) } tradeOfferId={ tradeOfferRequested.get('id') } />
      </React.Fragment>
    ))
  );
};

TradeOffersRequestedDesktop.propTypes = {
  onHandleShowTradeAcceptModal: PropTypes.func.isRequired,
  tradeOffersRequested: PropTypes.instanceOf(Immutable.Map).isRequired
};

export default TradeOffersRequestedDesktop;



// WEBPACK FOOTER //
// ./app/components/reps/trade_post/pending/TradeOffersRequestedDesktop.jsx